import React from 'react';

import AppLayoutProvider from '../LayoutContext/Providers/AppLayoutProvider';
import { useAppLayoutContext } from '../LayoutContext/hooks';
import AppLayout from './AppLayout';
import { IAppLayout } from './types';

const AppContextConsumer = (props: IAppLayout) => {
  const context = useAppLayoutContext();
  /*
    Spread context second to be able to override children props
  */
  return <AppLayout {...props} {...context} />;
};

/**
 * App Layout Component connected to layout context.
 *
 * Context determined prop values (IAppContext) can be overriden by parent.
 *
 * @param props.preventChildrenOverride - To be used by Pages to prevent
 * the AppLayout from replacing their children - see AppLayoutProvider.
 * Allows a bypass at the page level so a whole page can make still use the AppLayout
 * without the children override.
 *
 * Sidebar and Top navs will still be disabled where AppLayout determines
 * it.
 */
const ConnectedAppLayout = ({
  preventChildrenOverride,
  ...props
}: IAppLayout): JSX.Element => {
  return (
    <AppLayoutProvider preventChildrenOverride={preventChildrenOverride}>
      <AppContextConsumer {...props} />
    </AppLayoutProvider>
  );
};

export default ConnectedAppLayout;
